import * as Sentry from "@sentry/vue";

export function initSentry(app, router) {
  Sentry.init({
    app,
    dsn: "https://2bf382532b5a408b3b3e9674303dc88b@o4508438537175040.ingest.de.sentry.io/4509439292932176",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    enabled: process.env.NODE_ENV === "production",

    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/www\.portal-indufast\.nl/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
